import { createSlice } from '@reduxjs/toolkit';
import API from '../../api';
import { MESSAGES } from '../../utils/constants';

export const disaggregatedSlice = createSlice({
  name: 'disaggregated',
  initialState: {
    isLoading: false,
    isError: false,
    errorMessage: MESSAGES.SERVER_ERROR,
    data: null,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.isError = false;
    },
    fetchSuccess: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    fetchError: (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.payload;
    },
    clearData: (state) => {
      state.isLoading = false;
      state.isError = false;
      state.errorMessage = MESSAGES.SERVER_ERROR;
      state.data = null;
    },
  },
});

export const {
  fetchStart,
  fetchSuccess,
  fetchError,
  clearData,
} = disaggregatedSlice.actions;

export const fetchData = (date, integratorId, deviceType) => async (dispatch) => {
  try {
    dispatch(fetchStart());

    const response = await API.DISAGGREGATED(date, integratorId, deviceType);

    if (!response.data.numberOfDevices) {
      return dispatch(fetchError(MESSAGES.NO_DATA));
    }

    dispatch(fetchSuccess(response.data));
  } catch (err) {
    if (err.response && err.response.status === 404) {
      return dispatch(fetchError(MESSAGES.NO_DATA));
    }

    dispatch(fetchError(MESSAGES.SERVER_ERROR));
  }
};

export const selectIsLoading = (state) => state.disaggregated.isLoading;
export const selectIsError = (state) => state.disaggregated.isError;
export const selectErrorMessage = (state) => state.disaggregated.errorMessage;
export const selectData = (state) => state.disaggregated.data;

export default disaggregatedSlice.reducer;
